<template>
<div class="container-fluid" >

 <div class="card border-success">

  
    <h4 class="card-header text-white bg-primary"><i class="fas fa-infinity mr-2" aria-hidden="true"></i>RUNNING TOTAL CASSA</h4>
  

 <div  class="card-body"> 
 
<div class="row">


  <div v-if="type=='A'" class="col-md-4"> 

  <div class="card border-info" >
  <div class="card-header bg-info">
    <i style="color:yellow" class="fas fa-stream mr-2" aria-hidden="true"></i>
    <strong>PARAMETRI DI RICERCA</strong></div>
  <div class="card-body text-dark">
  <form name="movementSearch" v-on:submit.prevent="submit()">
      
        <store-select v-bind:props="store"  @update="setStoreId"></store-select>    
        <year-select  v-bind:props="season_year" @update="setYear"></year-select>
   
   
        
   
   

    <label for="input_data"><strong>MESE</strong></label>
        <select required class="form-control" id="month" v-model="month">
            <option :value="n" v-for="n in 12" :key="n">{{n}}</option>
        </select>
   

           
   <button :disabled="spinner" type="submit"  class="btn btn-primary mt-3 float-right">
    <i class="far fa-play-circle mr-2"></i>
    ESEGUI
      <span v-if="spinner" class="spinner-border spinner-border-sm ml-3" role="status" aria-hidden="true"></span>
     </button>           
    
    <!--
    <button @click="items=[],row_total=[]" type="button"   class="btn btn-warning ml-3">
        Reset
    </button>           
    -->

  </form>


</div>
</div>
</div>

<div v-else class="col">

  <button @click="type='A',chartData=[]"  type="button"  class="btn btn-secondary mb-1">
    <i style="color:yellow" class="fas fa-reply mr-2"></i>
    RITORNA A PARAMETRI RICERCA
      
     </button>  


  <!-- <div class="table-wrapper-scroll-y my-custom-scrollbar">-->

  <table class="table table-responsive table-bordered table-sm">
    <thead>
      <tr class="table-primary">
       <th v-for="(col,index) in cols" :key="index">
            <span>{{col}}</span>
       </th>     
        
      </tr>
    </thead>
    <tbody>
      <tr class="pointer" v-for="(item, index) in items" :key="index">
        
        <td v-for="(col,index) in cols" :key="index">
            <span v-if="col=='anno'" class="form-control-plaintext text-right">{{item[col]}}</span>
            <span :style="{color: item[col] > 0  ? 'blue' : 'black',fontWeight:item[col] >0 ? 'bold':'normal'}"  v-else class="form-control-plaintext text-right">{{fmt1(item[col])}}</span>
        </td>    
       
      </tr> 
    </tbody>
   
  </table>

  
<!---->
<!--</div> -->








</div>  





</div>
 </div>




 <alert-box style="margin-top:10px" @close="msg.title=''" v-bind:msg="msg"  ></alert-box>



 <GChart class="mt-4"  v-if="chartData.length>0"
      type="ColumnChart"
      :data="chartData"
      :options="chartOptions"
    />  

 


 </div>
  
  
  
 



</div>


</template>
<script>
import api               from "@/api";

import alertBox          from '@/components/common/AlertBox.vue';
import storeSelect       from '@/components/common/StoreSelect_1.vue'
import yearSelect        from '@/components/common/YearSelect_1.vue'
import { GChart }        from "vue-google-charts";
import fmt               from '@/components/mixins/fmt.js'


export default {
  mixins:[fmt],
  components: {alertBox,storeSelect,yearSelect,GChart},
  data() {
    return {
      
      
      type            : 'A',
    
      month           : 0,

      store             : 
      {
        Id            : 0,
        isActive      : true,
       
        optionBase    : false,
        required      : true
      },
      season_year     : 
      {
        year          : 0,
        isActive      : true,
       
        optionBase    : false,
        required      : true

      },
 

      spinner         : false,
      msg             : {

        title     : '',
        body      : '',
        type      : 0

      },
      
      items           : [],
      cols            : [],
      chartData: [
              
              ],
              chartOptions: {
                /*
                width  : 2000,
                height : 400,
                bar: { groupWidth: "80%" },  // width of bars here
                */
                /*
  chartArea: { width: '100%' },
  hAxis: {
    title: 'Mese di ',
    minValue: 0,
  },
  vAxis: {
    //title: '',
  },
  width: 1500,
  height: 600,

        */
 
      }        
      
    };
  },

  computed :{

   
  },
  directives: {
    focus: {
      // directive definition

      inserted : function(el) 
      {
        //el.focus();
      }

    }
  },
  mounted: function() {},
  created: function() {},
  methods: {

   
    setStoreId(storeId)
    {
        this.store.Id = storeId
    },
    setYear(year)
    {
        this.season_year.year = year
    },  
    
    
    submit() 
    {
      this.msg.title = ''
      this.getData()
    },  
    
    
    async getData() {
      
      this.cols = []  
      this.items = []
      
      

      this.msg.title = ''
      
      const sp = {'sp' : 'spPaymentRunningTotal'}
      
      const data  = {
         'storeId' :this.store.Id,'year':this.season_year.year,'month':this.month
      }
     
      const json  = Object.assign(data, sp)
      
      this.spinner = true
      await api.post(json).then(res => {
         
         
          if(res.status==200)
            {
              
            this.cols.push('anno')
            let  data = res.data.recordsets[0]
           
            for (var key in data[0]) {
                if( key !='anno')
                {
                    this.cols.push(key)
                }
              }  
            this.items = res.data.recordsets[0]
            
            if(this.items.length>1)
            {
              this.chartDataArray(this.items,this.season_year.year)
            }
            
            
            if(this.items.length==0)
              {
                
                this.msg.title = 'ATTENZIONE '
                this.msg.body = 'DATI INESISTENTI.'
                this.msg.type  = 1
                return
              }
              this.type = 'B'

            }
            else if (res.status==500)
            {
              
              this.msg.title = 'ATTENZIONE '
              this.msg.body  = res.data
              this.msg.type  = 1
              
            }
          
          else
          {

            
            this.msg.title = 'ATTENZIONE '
            this.msg.body  = res
            this.msg.type  = 1
                        

          }
      }).catch(err=>{
        
           
            this.msg.title = 'ATTENZIONE '
            this.msg.body  = err.message
            this.msg.type  = 1
        

      }).finally(() => {
          this.spinner = false
        });
      
   
       


    },
    
    chartDataArray(items,year)
    {
     
      this.chartData = []
      let chartData = []     
      let arr1 = Object.values(items[0])
      let arr2 = Object.values(items[1])
      let temp = []
      let year1 = year-1
      
      let arr = ['Giorno',year1.toString() ,year.toString()]
      chartData.push(arr)
      for (let i = 0; i < 31; i++) 
      {
              let n = i + 1
              temp.push(n.toString())
              temp.push(arr1[i] ? arr1[i] : 0)
              temp.push(arr2[i] ? arr2[i] : 0)
              chartData.push(temp)
              temp = []
              
      }
            
      this.chartData = chartData
           
    }
    
  }
};
</script>
<style scoped>


.my-custom-scrollbar {
position: relative;
height: 200px;
overflow: auto;
}
.pointer:hover
{
  _background-color: blue;
  color: white;
  cursor: pointer;
}


.table thead  tr:nth-child(1) th
 {

    font-family  : 'Roboto Condensed';
    font-size    : 16px;
    background   : #069317; 
    color        : white;   
    position     : sticky;
    top          : 0;
    z-index      : 10;

 }

.table tfoot  tr:nth-child(1) td
 {

    font-family  : 'Roboto Condensed';
    font-weight  : bold;
    font-size    : 20px;
    background   : #FFFFE0;
    color        : black;   
    position     : sticky;
    bottom       : 0;
    z-index      : 10;

 }

 .tfoot  tr:nth-child(1) th
 {

    font-family  : 'Roboto Condensed';
    font-size    : 16px;
    background   : #66CCFF; 
    color        : black;   
    position     : sticky;
    bottom       : 0;
    z-index      : 10;

 }
.table-wrapper-scroll-y {
display: block;
}
.table th:first-child
{
  border-radius : 0 0 0 10px;
}
.table th:last-child
{
  border-radius : 0 10px 0 0;  
}



h4 {
  font-family  : 'Roboto Condensed';
  font-size    : 20px;
}

</style>